// extracted by mini-css-extract-plugin
module.exports = {"o8jiojw":"o8jiojw","c1w3c3xa":"c1w3c3xa","wtjclid":"wtjclid","szxmz3j":"szxmz3j","sqzyt6s":"sqzyt6s"};